<template>
  <div class="growth-container">
    <div class="operation-bar">
      <el-button type="primary" size="mini" @click="handleCreate">新增</el-button>
      <el-button type="danger" size="mini" @click="handleBatchDelete" :disabled="!selectedRows.length">删除</el-button>
      <div class="search-box">
        <el-select v-model="searchStatus" placeholder="状态" style="width: 200px" size="mini" clearable>
          <el-option label="启用" :value="1"></el-option>
          <el-option label="禁用" :value="0"></el-option>
        </el-select>
        <el-button icon="el-icon-search" style="margin-left: 10px" size="mini" type="primary" @click="handleSearch"
          >查询</el-button
        >
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="序号" type="index" width="80" align="center"> </el-table-column>
      <el-table-column prop="stageName" label="生长时期"></el-table-column>
      <el-table-column prop="judgmentCriteria" label="判定标准"></el-table-column>
      <el-table-column prop="precautions" label="注意事项">
        <template slot-scope="scope">
          <div>{{ scope.row.precautions }}</div>
        </template>
      </el-table-column>
      <el-table-column label="标准时长区间（天）">
        <template slot-scope="scope"> {{ scope.row.stdDurationMin }} - {{ scope.row.stdDurationMax }} </template>
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间"></el-table-column>
      <el-table-column prop="enabled" label="启用">
        <template slot-scope="scope">
          <el-tag :type="scope.row.enabled === 1 ? 'success' : 'info'">{{
            scope.row.enabled === 1 ? '启用' : '禁用'
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" style="color: #2680dd" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: #04ff9f" @click="handleView(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="900px" @close="handleDialogClose">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="140px">
        <template v-if="!isEdit">
          <el-table :data="formData.items" border style="width: 100%">
            <el-table-column prop="index" label="序号" width="60">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column label="生长时期">
              <template slot-scope="scope">
                <el-input v-model="scope.row.stageName" placeholder="请输入" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="判定标准">
              <template slot-scope="scope">
                <el-input v-model="scope.row.judgmentCriteria" placeholder="请输入" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="注意事项">
              <template slot-scope="scope">
                <el-input v-model="scope.row.precautions" placeholder="请输入" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="标准时长区间（天）">
              <template slot-scope="scope">
                <el-input-number
                  :controls="false"
                  v-model="scope.row.stdDurationMin"
                  :min="1"
                  :step="0"
                  :precision="0"
                  placeholder="最小值"
                  size="mini"
                  style="width: 80px"
                ></el-input-number>
                -
                <el-input-number
                  :controls="false"
                  v-model="scope.row.stdDurationMax"
                  :min="1"
                  :step="1"
                  :precision="0"
                  placeholder="最大值"
                  size="mini"
                  style="width: 80px"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="启用" width="80">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.enabled" :active-value="1" :inactive-value="0"></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="color: #f56c6c"
                  @click="removeStage(scope.$index)"
                  v-if="formData.items.length > 1"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" icon="el-icon-plus" plain style="margin: 10px 0; width: 100%" @click="addStage"
            >添加</el-button
          >
        </template>
        <template v-else>
          <el-form-item label="生长时期">
            <el-input v-model="formData.single.stageName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="判定标准">
            <el-input v-model="formData.single.judgmentCriteria" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="注意事项">
            <el-input v-model="formData.single.precautions" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="标准时长区间（天）">
            <el-input-number
              :controls="false"
              v-model="formData.single.stdDurationMin"
              :min="1"
              :step="1"
              :precision="0"
              placeholder="最小值"
              style="width: 80px"
            ></el-input-number>
            -
            <el-input-number
              :controls="false"
              v-model="formData.single.stdDurationMax"
              :min="1"
              :step="1"
              :precision="0"
              placeholder="最大值"
              style="width: 80px"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="启用">
            <el-switch v-model="formData.single.enabled" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 查看弹窗 -->
    <el-dialog title="查看生长周期" :visible.sync="viewDialogVisible" width="600px">
      <el-table :data="viewData" border style="width: 100%">
        <el-table-column prop="stageName" label="生长时期"></el-table-column>
        <el-table-column prop="judgmentCriteria" label="判定标准"></el-table-column>
        <el-table-column prop="precautions" label="注意事项">
          <template slot-scope="scope">
            <div>{{ scope.row.precautions }}</div>
          </template>
        </el-table-column>
        <el-table-column label="标准时长区间（天）">
          <template slot-scope="scope"> {{ scope.row.stdDurationMin }} - {{ scope.row.stdDurationMax }} </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';

export default {
  name: 'GrowthManagement',
  data() {
    return {
      tableData: [],
      selectedRows: [],
      searchStatus: '',
      page: 1,
      pageSize: 10,
      totalCount: 0,
      dialogVisible: false,
      dialogTitle: '新增',
      formData: {
        items: [
          {
            stageName: '',
            judgmentCriteria: '',
            stdDurationMin: null,
            stdDurationMax: null,
            enabled: 1,
            precautions: '',
          },
        ],
        single: {
          id: '',
          stageName: '',
          judgmentCriteria: '',
          stdDurationMin: null,
          stdDurationMax: null,
          enabled: 1,
          precautions: '',
        },
      },
      isEdit: false,
      editId: null,
      rules: {},
      viewDialogVisible: false,
      viewData: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取数据
    async fetchData() {
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          enabled: this.searchStatus,
        };
        const res = await axios.post(baseUrl + '/api/basic/growth-stage/list-page', params);
        if (res.code === 200) {
          this.tableData = res.data.list || [];
          this.totalCount = parseInt(res.data.totalCount) || 0;
        }
      } catch (error) {
        this.$message.error('获取生长周期列表失败');
      }
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleSearch() {
      this.page = 1;
      this.fetchData();
    },
    handleCreate() {
      this.isEdit = false;
      this.dialogTitle = '新增';
      this.dialogVisible = true;
      this.formData.items = [
        {
          stageName: '',
          judgmentCriteria: '',
          stdDurationMin: null,
          stdDurationMax: null,
          enabled: 1,
          precautions: '',
        },
      ];
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = '编辑';
      this.dialogVisible = true;
      this.formData.single = { ...row };
    },
    handleView(row) {
      console.log(row);

      this.viewData = [row];
      this.viewDialogVisible = true;
    },
    handleDialogClose() {
      this.isEdit = false;
      this.editId = null;
      this.formData.items = [
        {
          stageName: '',
          judgmentCriteria: '',
          stdDurationMin: null,
          stdDurationMax: null,
          enabled: 1,
          precautions: '',
        },
      ];
      this.formData.single = {
        id: '',
        stageName: '',
        judgmentCriteria: '',
        stdDurationMin: null,
        stdDurationMax: null,
        enabled: 1,
        precautions: '',
      };
    },
    addStage() {
      this.formData.items.push({
        stageName: '',
        judgmentCriteria: '',
        stdDurationMin: null,
        stdDurationMax: null,
        enabled: 1,
        precautions: '',
      });
    },
    removeStage(index) {
      this.formData.items.splice(index, 1);
    },
    handleSubmit() {
      if (this.isEdit) {
        // 编辑单条校验
        const item = this.formData.single;
        if (!item.stageName || !item.judgmentCriteria || item.stdDurationMin === null || item.stdDurationMax === null) {
          this.$message.error('生长时期、判定标准、标准时长区间（天）为必填');
          return;
        }
        if (item.stdDurationMin > item.stdDurationMax) {
          this.$message.error('最小值不能大于最大值');
          return;
        }
        const payload = { ...item };
        const url = '/api/basic/growth-stage/edit';
        axios.post(baseUrl + url, payload).then((res) => {
          if (res.code === 200) {
            this.$message.success('更新成功');
            this.dialogVisible = false;
            this.fetchData();
            this.$store.dispatch('farm/getStageOptions');
          }
        });
      } else {
        // 新增批量校验
        for (let item of this.formData.items) {
          if (
            !item.stageName ||
            !item.judgmentCriteria ||
            item.stdDurationMin === null ||
            item.stdDurationMax === null
          ) {
            this.$message.error('生长时期、判定标准、标准时长区间（天）为必填');
            return;
          }
          if (item.stdDurationMin > item.stdDurationMax) {
            this.$message.error('最小值不能大于最大值');
            return;
          }
        }
        const items = this.formData.items.map((item) => ({
          ...item,
          enabled: item.enabled ? 1 : 0,
        }));
        const payload = { items };
        const url = '/api/basic/growth-stage/add-batch';
        axios.post(baseUrl + url, payload).then((res) => {
          if (res.code === 200) {
            this.$message.success('新增成功');
            this.dialogVisible = false;
            this.fetchData();
          }
        });
      }
    },
    async handleBatchDelete() {
      if (!this.selectedRows.length) return;
      try {
        await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个生长周期吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        const ids = this.selectedRows.map((row) => row.id);
        const res = await axios.post(baseUrl + '/api/basic/growth-stage/delete-batch', ids);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.fetchData();
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('批量删除失败');
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped lang="less">
.growth-container {
  padding: 20px;

  .operation-bar {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .search-box {
      margin-left: auto;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
}

.dialog-footer {
  text-align: center;
}
</style>
